import { Button, Group, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router-dom';

interface ErrorFallbackProps {
  eventId?: string;
}

export const ErrorFallback = ({ eventId }: ErrorFallbackProps) => (
  <Stack align="center" justify="center" gap="md" mih="60vh" p="xl" role="alert">
    <Title order={2}>Something went wrong</Title>
    <Text c="dimmed" ta="center" maw={480}>
      An unexpected error occurred while displaying this page. Reloading usually fixes it. If the
      problem persists, contact support and include the reference below.
    </Text>
    {eventId && (
      <Text size="sm" c="dimmed">
        Reference: {eventId}
      </Text>
    )}
    <Group>
      <Button onClick={() => window.location.reload()}>Reload page</Button>
      <Button component={Link} to="/" variant="default" reloadDocument>
        Go to home
      </Button>
    </Group>
  </Stack>
);
